/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AsyncJobType {
    DATA_LOADER = 'dataLoader',
    RECALCULATE_AGING_FACTOR = 'recalculateAgingFactor',
    RECALCULATE_COMPOSITE_TAG = 'recalculateCompositeTag',
    RECALCULATE_PLAN = 'recalculatePlan',
    RECALCULATE_COMPOSITES = 'recalculateComposites',
    RECALCULATE_COMPANY_JOB_STATS = 'recalculateCompanyJobStats',
    RECALCULATE_SURVEY_JOB_STATS = 'recalculateSurveyJobStats',
    RECALCULATE_SURVEY_CUT_STATS = 'recalculateSurveyCutStats',
    RESET_DEFAULT_CUTS = 'resetDefaultCuts',
    MIGRATE_PLAN = 'migratePlan',
    UPDATE_PLAN = 'updatePlan',
    CREATE_PAYMARKET = 'createPaymarket',
    UPDATE_CUSTOM_PERCENTILE = 'updateCustomPercentile',
    ADD_INDEXED_DATA_CUTS = 'addIndexedDataCuts',
    REMOVE_INDEXED_DATA_CUTS = 'removeIndexedDataCuts',
    DELETE_LOAD = 'deleteLoad',
    DELETE_SURVEY = 'deleteSurvey',
    RECALCULATE_SLOT_JOB = 'recalculateSlotJob',
    EXPORT_DATA = 'exportData',
    EXPORT_EXCEL = 'exportExcel',
    RECALCULATE_PLAN_STATS = 'recalculatePlanStats',
    SETUP_COMPANY = 'setupCompany',
    RECALCULATE_DATA_MODEL_COMPOSITE_STATS = 'recalculateDataModelCompositeStats',
    RECALCULATE_DATA_MODEL_WITH_AUTO_SPREAD = 'recalculateDataModelWithAutoSpread',
    PUBLISH_SURVEY_REPLACEMENT = 'publishSurveyReplacement',
    APPLY_CUT_SELECTION_POLICY_SURVEY_REPLACEMENT = 'applyCutSelectionPolicySurveyReplacement',
    ACTUALIZE_SURVEY_JOB_MAPPING_REPLACEMENT = 'actualizeSurveyJobMappingReplacement',
    ACTUALIZE_COMPOSITE_DATA_CUT_REPLACEMENT = 'actualizeCompositeDataCutReplacement',
    INITIATE_RECALCULATION = 'initiateRecalculation',
    SYNC_DATAHUB = 'syncDatahub',
    TEST_HRIS_URL = 'testHrisUrl',
    GENERATE_JOB_DESCRIPTION = 'generateJobDescription',
    APPLY_WEIGHTING_POLICY = 'applyWeightingPolicy',
    CLEANUP_CS_ADMIN_TENANCIES = 'cleanupCsAdminTenancies',
    ACTIVATE_DRAFT_PLAN = 'activateDraftPlan',
    ADD_DEFAULT_DATA_CUTS_FOR_JOB_MAPPINGS = 'addDefaultDataCutsForJobMappings',
    GET_SURVEY_DATA_BY_POLICY_RESPONSE = 'getSurveyDataByPolicyResponse',
    GET_DEFAULT_DATA_CUTS_RESPONSE = 'getDefaultDataCutsResponse',
    PROCESS_SRW_CUT_SELECTION_RESPONSE = 'processSrwCutSelectionResponse',
}
